import {
  SwapHoriz as SwapHorizIcon,
  GroupAdd as GroupAddIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  Add as AddIcon,
  CheckCircle as CheckCircleIcon,
  RateReview as RateReviewIcon,
  ThumbUp as ThumbUpIcon,
  Notifications as DefaultNotificationIcon,
} from '@mui/icons-material';
import { NotificationType } from '../../types/workflow';

/**
 * Get the appropriate icon for a notification type.
 */
export const getNotificationIcon = (type: NotificationType | string) => {
  switch (type) {
    case NotificationType.WorkflowTransition:
      return <SwapHorizIcon />;
    case NotificationType.TeamAssignment:
      return <GroupAddIcon />;
    case NotificationType.SlaWarning:
      return <WarningIcon color="warning" />;
    case NotificationType.SlaBreached:
      return <ErrorIcon color="error" />;
    case NotificationType.BatchCreated:
      return <AddIcon color="primary" />;
    case NotificationType.BatchCompleted:
      return <CheckCircleIcon color="success" />;
    case NotificationType.ReviewRequired:
      return <RateReviewIcon color="info" />;
    case NotificationType.ApprovalRequired:
      return <ThumbUpIcon color="primary" />;
    default:
      return <DefaultNotificationIcon />;
  }
};
